const DeviceReplacement = {
  DeviceReplacement: {
    toDoText: 'Certifique-se de que os seguintes passos foram executados antes de iniciar a substituição',
    toDoListItems: [
      'Desligue o dispositivo a ser substituído',
      'Ligar o dispositivo de substituição',
      'Configurar o dispositivo de substituição'
    ],
    install_replacement: {
      submitFirstStep: 'Obter pormenores',
      hems_device_api_fault:
        'Se estiver a tentar substituir uma carga de terceiros ativa mas não a conseguir ver no menu pendente, recarregue a página.',
      labelOldDevice: 'Detalhes do dispositivo antigo',
      labelNewDevice: 'Detalhes do dispositivo novo',
      submitSecondStep: 'Confirmar a substituição',
      warningText:
        'Caso os detalhes do dispositivo estejam incorrectos ou para qualquer outro problema, <a style="color:#F37321;"  href="javascript: window.parent.location.reload();" >clique aqui</a> para voltar atrás',
      DeviceTypes: {
        EVSE: 'IQ ER EVSE',
        ENERGY_METER: 'Medidor de energia',
        SG_READY_GATEWAY: 'Relé de prontidão SG',
        MICROINVERTER: 'Microinversor',
        AC_BATTERY: 'Bateria CA',
        selectDeviceType: 'selecionar o tipo de dispositivo'
      }
    },
    replace_gateway: {
      submitFirstStep: 'Substituir o IQ Energy Router',
      hems_device_api_fault:
        'Se estiver a tentar substituir um IQ Energy Router ativo, mas não conseguir vê-lo no menu pendente, recarregue a página.',
      submitSecondStep: 'Substituir o IQ Energy Router',
      labelOldDevice: 'Detalhes do IQ ER antigo',
      labelNewDevice: 'Detalhes do novo IQ ER',
      warningText:
        'Caso os detalhes do dispositivo estejam incorrectos ou para qualquer outro problema, <a style="color:#F37321;"  href="javascript: window.parent.location.reload();" >clique aqui</a> para voltar atrás',
      DeviceTypes: {
        IQ_ENERGY_ROUTER: 'IQ Energy Router',
        IQ_GATEWAY: 'IQ Gateway',
        selectDeviceType: 'Selecionar o tipo de gateway'
      }
    },
    alert: {
      footerMessage: 'Caso o problema persista, contacte o Apoio ao Cliente da Enphase',
      requestTimedOut: {
        mainMessage: 'O pedido expirou',
        subMessage: 'Por favor, tente novamente mais tarde'
      },
      multipleDeviceFound: {
        mainMessage: 'Substituição não suportada',
        subMessageIqErEvse:
          'Foram detectados mais de 1 IQ ER EVSE no local. A substituição não pode ser suportada para este tipo de configuração do local',
        subMessageEnergyMeter:
          'Foram detectados mais de 1 contadores de energia no local. A substituição não pode ser suportada para este tipo de configuração do local',
        subMessageSgReadyRelay:
          'Foram detectados mais de 1 relés SG Ready no local. A substituição não pode ser suportada para este tipo de configuração do local'
      },
      iqErOffline: {
        mainMessage: 'IQ ER não está informando',
        subMessage: 'Certifique-se de que o IQ Energy Router está ligado e conectado à Internet'
      },
      deviceNotOffline: {
        mainMessage: 'Dispositivo antigo ligado',
        subMessage:
          'Foi detectada a ligação de um dispositivo antigo. Por favor, desligue o dispositivo antigo e reinicie a substituição'
      },
      deviceReplacementInProgress: {
        mainMessage: 'A substituição do dispositivo já está a decorrer para este tipo de dispositivo'
      },
      deviceNotFound: {
        mainMessage: 'Novo dispositivo não detectado',
        subMessage:
          'Os detalhes do novo dispositivo não foram encontrados. Certifique-se de que o novo dispositivo está ligado à Internet e configurado'
      },
      invalidRmaStatusId: {
        mainMessage: 'Falha na substituição ',
        subMessage: 'A substituição falhou devido a um estado de substituição desconhecido'
      },
      activationDuplicateSite: {
        mainMessage: 'Falha na substituição',
        subMessage: 'A substituição falhou porque o novo IQ Energy Router já está ativo'
      },
      authPending: {
        mainMessage: 'Falha na substituição',
        subMessage: 'A substituição falhou porque o IQ Energy Router existente ainda não foi autorizado'
      },
      invalidIqEnergyRouter: {
        mainMessage: 'Falha na substituição',
        subMessage: 'A substituição falhou porque o número de série do IQ Energy Router introduzido não é válido'
      },
      hemsDevicesNotDiscovered: {
        mainMessage: 'Falha na substituição',
        subMessage:
          'A substituição falhou porque os dispositivos HEMS de terceiros anteriormente detectados não foram encontrados'
      },
      iqGatewayNotDiscovered: {
        mainMessage: 'Falha na substituição',
        subMessage: 'A substituição falhou porque o IQ Gateway ainda não foi detectado pelo IQ Energy Router'
      },
      authInitFailed: {
        mainMessage: 'Falha na substituição',
        subMessage: 'A substituição falhou porque a autorização do dispositivo não foi iniciada'
      },
      invalidDeviceType: {
        mainMessage: 'Tipo de dispositivo não válido para substituição',
        subMessage: 'Certifique-se de que foi selecionado o tipo de dispositivo correto antes de submeter o pedido'
      },
      invalidSite: {
        mainMessage: 'Tipo de local não suportado',
        subMessage: 'A configuração do local não é compatível com esta substituição'
      },
      invalidDevice: {
        mainMessage: 'O ID do dispositivo antigo parece inválido',
        subMessage: 'A substituição não é suportada para este dispositivo'
      },
      invalidDeviceUid: {
        mainMessage: 'Os IDs de dispositivo antigo e novo são os mesmos',
        subMessage: 'A substituição não é suportada para este dispositivo'
      },
      deviceReplacementCompleted: {
        mainMessage: 'Substituição concluída',
        subMessage:
          'Se a validação funcional estiver pendente para o novo dispositivo, conclua-a usando o aplicativo Enphase Installer Application (ITK).'
      },
      itkSuccessMessage: {
        iqErEvse: 'EV Charger substituído com sucesso',
        energyMeter: 'Energy Meter substituído com sucesso',
        sgReadyRelay: 'SG Ready Relay substituído com sucesso',
        iqEnergyRouter: 'Router de energia IQ substituído com sucesso'
      },
      fetchingDeviceDetailsLoader: { subMessage: 'Obtenção de detalhes do dispositivo' },
      initiatingReplacementLoader: { subMessage: 'Iniciar a substituição' },
      replacementInprogressLoader: { subMessage: 'Substituição em curso' }
    }
  }
};

export default DeviceReplacement;
